// Sources to be used as we move towards standardizing more aspects of analytics tracking
export const SIDEBAR = 'sidebar';
export const WORKSPACE_SELECTOR = 'workspace_selector';
export const TEAM_MANAGEMENT = 'team_management';
export const INVITE_TEAMMATES_MODAL = 'invite_teammates_modal';
export const SERVER = 'server';
